<template>
  <div id="nescss">
    <div class="container">
      <section class="icon-list">
        <h1>Advanced Search</h1>
        <h2>On Sale</h2>
        <h3 v-if="saleCount">{{ saleCount }} NFTs</h3>
        <h1 v-else>Loading...</h1>
        <label for="maxPerPage_select">Select number of Doggys per page</label>
        <div class="nes-select" style="padding-bottom: 15px">
          <select
            v-model="maxPerPage"
            @click="getDoggy(0)"
            @change="getDoggy(0)"
            required
            id="maxPerPage_select"
          >
            <option :value="50">50</option>
            <option :value="75">75</option>
            <option :value="100">100</option>
            <option :value="150">150</option>
            <option :value="200">200</option>
          </select>
        </div>
        <label for="doggytype_select">Select type of Doggy</label>
        <div class="nes-select" style="padding-bottom: 15px">
          <select
            v-model="doggyType"
            @change="getDoggy()"
            required
            id="doggytype_select"
          >
            <option value="null">None</option>
            <option
              v-for="(type, index) in this.$options.doggyTypes"
              :key="index"
              :value="type"
            >
              {{ type }}
            </option>
          </select>
        </div>
        <label for="accessoryName_select">Accessory Type</label>
        <div class="nes-select" style="padding-bottom: 15px">
          <select
            v-model="accessoryName"
            @change="getDoggy()"
            required
            id="accessoryName_select"
          >
            <option disabled value="null">Accessory Type</option>
            <option
              v-for="(type, index) in this.$options.accessoryNames"
              :key="index"
              :value="type"
            >
              {{ type }}
            </option>
          </select>
        </div>
        <label for="collectibleValue_select">Collectible Value</label>
        <div class="nes-select" style="padding-bottom: 15px">
          <select
            v-model="collectibleValue"
            @change="getDoggy()"
            required
            id="collectibleValue_select"
          >
            <option disabled value="null">Collectible Value</option>
            <option
              v-for="(type, index) in this.$options.collectibleValues"
              :key="index"
              :value="type"
            >
              {{ type }}
            </option>
          </select>
        </div>
        <div v-if="doggys">
          <div v-for="(vals, index) in doggys" :key="index" class="dd">
            <img
              :src="vals.imageUrl"
              onerror="javascript:this.src='https://via.placeholder.com/300';"
              class="nes-icon is-large"
              style="background: #8e6fb6"
              @click="getDoggyAttributes(vals.nftid)"
            />
            <div class="overlay">{{ vals.nftid }}</div>
          </div>
          <div class="pagination center">
            <a href="#" @click="movePage('backward', curPage)">&laquo;</a>
            Page {{ curPage + 1 }}/{{ offsets }}
            <a href="#" @click="movePage('forward', curPage)">&raquo;</a>
          </div>
          <p>Found {{ totaldoggys.length }} NFTs</p>
        <p>Click/Tap on the Doggy to see it's details below!</p>
        </div>
        <div v-else>
          <p>No Doggy Found!</p>
          <p>Adjust your query please</p>
        </div>
      </section>
      <main v-if="dog && doggys" class="main-content" ref="printMe">
        <section class="showcase">
          <section class="nes-container with-title">
            <h3 class="title">Doggy #{{ dognftid }}</h3>
            <div class="nes-table-responsive">
              <img
                :alt="dognftid"
                width="256"
                height="256"
                :src="dogimg"
                style="margin-bottom: 10px"
              />
              <table class="nes-table is-bordered is-centered tab">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vals, name, index) in dog" :key="index">
                    <td style="text-transform: capitalize">{{ name }}</td>
                    <td
                      v-if="name == 'Mint Details'"
                      style="text-transform: capitalize"
                    >
                      {{ vals | nftMintTimeDate(vals) }}
                      <br />{{ vals | timeFromNow(vals) }}
                    </td>
                    <td v-else style="text-transform: capitalize">
                      {{ vals }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </section>
      </main>
      <p></p>
    </div>
  </div>
</template>
<script>
import {
  movePage,
  getDoggyAttributes,
  getDoggy,
  filterArray,
  setPageoff,
} from "./advancedSearchFunctions";
import JS from "./file.json";
import moment from 'moment'
export default {
  filters: {
    nftMintTimeDate(data) {
      if (data == 0) {
        return "Not Minted Yet!";
      } else {
        console.log("in here", data, moment(data).format());
        return moment.unix(data).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    timeFromNow(data) {
      if (data != 0) {
        return moment.unix(data).fromNow();
      }
      return;
    },
  },
  data() {
    return {
      dog: null,
      collectibleValue: null,
      totaldoggys: {},
      offsets: 0,
      curPage: 0,
      accessoryName: null,
      doggyType: null,
      doggys: {},
      maxPerPage: 50,
      saleCount: null,
    };
  },
  created() {
    document.title = "Advanced - On Sale Search"
    console.log(JS[0]);
    this.getDoggy();
  },
  collectibleValues: ["14", "8", "7", "6", "4", "3", "2", "1"],
  doggyTypes: [
    "Chihuahua",
    "Collie",
    "Bulldog",
    "Huskie",
    "Beagle",
    "Basset-Hound",
    "Pug",
    "Terrier",
    "Shih-Tzu",
    "Shiba-Inu",
    "Gold-Retriever",
  ],
  accessoryNames: [
    "None",
    "Glasses",
    "Toque",
    "Goggles",
    "Scarf",
    "Reading-Glasses",
    "Ball-Cap",
    "Fancy-Hat",
    "Bow-Tie",
  ],
  methods: {
    movePage,
    getDoggyAttributes,
    getDoggy,
    filterArray,
    setPageoff,
  },
};
</script>

<style>
</style>